module.exports = "<!-- RIBBON -->\n<div id=\"ribbon\">\n  <ng-template #tipContent><i class=\"text-warning fa fa-warning\"></i> Warning! This will reset all your widget settings.</ng-template>\n\n    <span class=\"ribbon-button-alignment\">\n      <span id=\"refresh\" class=\"btn btn-ribbon\" (click)=\"resetWidgets()\"\n            placement=\"bottom\"\n            [tooltip]=\"tipContent\">\n        <i class=\"fa fa-refresh\"></i>\n      </span>\n    </span>\n  <sa-route-breadcrumbs></sa-route-breadcrumbs>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/layout/ribbon/ribbon.component.html
// module id = ./src/app/shared/layout/ribbon/ribbon.component.html
// module chunks = main